import { RequireCapability } from "@/components/RequireCapability";

import { CatalogueApp } from "./components/CatalogueApp";
// Registers the slice's catalogue.* translations (side-effect import), and the
// tools / financial-aids / expert strings the shared order dialog and pickers read.
import "./i18n";
import "@/features/expert/i18n";
import "@/features/financial-aids/i18n";
import "@/features/tools/i18n";

/**
 * « Contenu du questionnaire » (route: /catalogue). Gated on `backOffice`, which
 * reads the API's `is_admin` — the same population as `IsAdminUser` behind
 * every catalogue endpoint and `AdminRequiredMixin` on the Django pages.
 */
export function CataloguePage() {
  return (
    <RequireCapability required={["backOffice"]}>
      <CatalogueApp />
    </RequireCapability>
  );
}
